class ReactivateReasonViewController extends MUIViewController
{
    static newInstance() : ReactivateReasonViewController {
        let vc = new ReactivateReasonViewController("reactivate-reason-view");
        vc.initWithResource("layout/leavereason/ReactivateReasonView.html");
        return vc;
    }

    get preferredContentSize(){
        return new MIOSize(500, 500);
    }

    private closeButton:MUIButton = null;
    private reactivateButton:MUIButton = null;

    private reasonTypeDropdown:MUIButton = null;
    private authorizeByTextField:MUITextField = null;
    private dateTextField:MUITextField = null;
    private dateButton:MUIButton = null;
    private reasonTextArea:MUITextArea = null;

    private reactivateReasonType:BusinessReasonType = null;
    private reactivateAuthorizationBy:string = null;
    private reactivateDate:Date = null;
    private reactivateReason:string = null

    private df = ( MUIWebApplication.sharedInstance().delegate as AppDelegate ).dateFormatter;

    viewDidLoad(){
        super.viewDidLoad();

        this.closeButton = MUIOutlet( this, "close-btn", "MUIButton");
        this.closeButton.setAction( this, function( this:ReactivateReasonViewController ) {
            this.dismissViewController( true );
        });

        this.reactivateButton = MUIOutlet( this, "reactivate-btn", "MUIButton");
        this.reactivateButton.setAction( this, function( this:ReactivateReasonViewController ) {
            this.save();
        });

        this.reasonTypeDropdown = MUIOutlet(this, "concept-dd", "MUIButton");
        this.reasonTypeDropdown.setAction(this, function(this:ReactivateReasonViewController) {
            AppHelper.sharedInstance().showSelectBusinessReasonTypeViewControllerFromView(this.reasonTypeDropdown, this.reactivateReasonType, BusinessReasonTypeScope.reactivate, this, function(this:ReactivateReasonViewController, controller:any, object:BusinessReasonType){
                this.reactivateReasonType = object;
                this.reasonTypeDropdown.title = object?.title;
            });
        });


        this.authorizeByTextField = MUIOutlet( this, "name-tf", "MUITextField");
        this.authorizeByTextField.setOnChangeText( this, function( this:ReactivateReasonViewController, control:MUITextField, value:string){
            this.reactivateAuthorizationBy = value.trim().length > 0 ? value.trim() : null;
        });

        this.dateTextField = MUIOutlet( this, "date-tf", "MUITextField");
        this.dateTextField.formatter = this.df;
        this.dateTextField.setOnChangeText( this, function(this:ReactivateReasonViewController, control:MUITextField, value:string){
            this.reactivateDate = this.df.dateFromString( value );
        });


        this.dateButton = MUIOutlet( this, "date-btn", "MUIButton");
        this.dateButton.tag = 1;
        this.dateButton.setAction( this, function( this:ReactivateReasonViewController) {
            this.showDatePickerController( this.dateButton );
        });

        this.reasonTextArea = MUIOutlet( this, "comments-ta", "MUITextArea");
        this.reasonTextArea.setOnChangeText( this, function( this:ReactivateReasonViewController, control:MUITextArea, value:string){
            this.reactivateReason = value.trim().length > 0 ? value.trim() : null;
        });
    }

    private _business:BusinessLicense = null;
    set business( business:BusinessLicense) {
        this._business = business;
    }

    private showDatePickerController( button: MUIButton ){
        let dp = new MUIDatePickerController();
        dp.init();
        dp.delegate = this;
        dp.modalPresentationStyle = MUIModalPresentationStyle.Popover;
        dp.tag = button.tag;

        let pc = dp.popoverPresentationController;
        pc.sourceRect = button.frame;
        pc.sourceView = button;

        AppHelper.sharedInstance().presentViewController(dp, true);
    }

    didSelectDate(controller:MUIDatePickerController, date:Date){
        switch (controller.tag) {
            case 1:
                this.reactivateDate = date;
                this.dateTextField.text = this.df.stringFromDate( date );
            break;
        }
    }


    private save()
    {
        if (this.reactivateReasonType == null) {
            AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("PLEASE_SELECT_A_REASON_TYPE", "PLEASE SELECT A REASON TYPE"));
            return;
        }

        if (this.reactivateAuthorizationBy == null) {
            AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("PLEASE_TYPE_WHO_GAVE_THE_ORDER", "PLEASE TYPE WHO GAVE THE ORDER"));
            return;
        }

        if (this.reactivateDate == null) {
            AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("PLEASE_SELECT_A_DATE", "PLEASE SELECT A DATE"));
            return;
        }

        if (this.reactivateReason == null) {
            AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("PLEASE_TYPE_A_REASON", "PLEASE TYPE A REASON"));
            return;
        }

        this._business.active = true;
        this._business.leaveReasonType = null;
        this._business.leaveAuthorizationBy = null;
        this._business.leaveDate = null;
        this._business.leaveReason = null;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let log = MIOEntityDescription.insertNewObjectForEntityForName( "ReactivationReasonLog", ad.managedObjectContext ) as ReactivationReasonLog;

        log.business = this._business;
        log.user = ad.selectedUser;
        log.userName = ad.selectedUser.name;
        log.date = new Date();
        log.type = this.reactivateReasonType;
        log.reactivationDate = this.reactivateDate;
        log.message = MIOLocalizeString("AUTHORIZED_BY", "AUTHORIZED BY") + ": " + this.reactivateAuthorizationBy + ". " + this.reactivateReason;

        this.closeButton.enabled = false;
        this.reactivateButton.enabled = false;

        DBHelper.queryObjectsWithCompletion( "License", null, MIOPredicate.predicateWithFormat("business = " + this._business.identifier ), [], this, function(this:ReactivateReasonViewController, licenses:License[]){
            this.closeButton.enabled = false;
            this.reactivateButton.enabled = false;

            for (let lic of licenses) {
                lic.active = true;
            }

            DBHelper.saveMainContext();
            this.dismissViewController( true );
        });
    }
}
